import axios from "axios";
import React from "react";
import object from "lodash/object"
import liff from "@line/liff";
import AppConfig from './AppConfig.json'

let traceId = makeid(18).toLowerCase()

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    async componentDidCatch(error, errorInfo) {
        // Display fallback UI
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, info);
        // console.log(error, errorInfo)

        sendLog(error.toString(), errorInfo.componentStack.toString())

    }

    render() {

        return this.props.children;
    }
}


function makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHJKMNPQRSTUVWXYZ123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

function getBrowser() {
    var ua = window.navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
        name: M[0],
        version: M[1]
    };
}

export async function sendLog(error, message, type = "error") {
    let user = liff.isLoggedIn() ? (await liff.getProfile()).userId : ""
    let agent = window.navigator.userAgent
    let browser = getBrowser()
    let environment = AppConfig.env
    let url = window.location.href
    let ipinfo = ''

    if (user) {
        user = object.pick(user, ["uid", "lastLoginAt", "phoneNumber", "email"])
    }

    try {
        let result = await axios.get('https://www.cloudflare.com/cdn-cgi/trace')
        ipinfo = result.data
    }
    catch (e) { }

    let logData = { type, url, environment, uid: user && user.uid, user, agent, browser, ipinfo, trace_id: traceId, error, message }

    if (AppConfig.env !== 'prod') {
        // console.log("Error Log:", logData)
        //     axios.post("https://gcs-elastic-log-lz7gpupm4a-uc.a.run.app/logs/t1-line-frontend", JSON.stringify(logData))
        // }
        // else {
        try {
            await axios.post("https://gcs-elastic-log-lz7gpupm4a-uc.a.run.app/logs/t1-line-frontend", JSON.stringify(logData))
        }
        catch (e) { console.error(`Cannot send log to server ${e}`) }
    }
}
